import { ElementNotFound } from "@senciamatch/frontend/components/ElementNotFound";
import { LoadingData } from "@senciamatch/frontend/components/LoadingData";
import { useDebounce } from "@senciamatch/frontend/hooks/useDebounce";
import { trpc } from "@senciamatch/frontend/libs/trpc";
import type { Building } from "@senciamatch/shared/models/building";
import { useState } from "react";
import { BuildingTable } from "./table";

interface Props {
  onSelect: (building: Building) => void;
  onClose: () => void;
}

export const BuildingSelectModal = ({ onSelect, onClose }: Props) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebounce(search, 500);

  const getBuildings = trpc.getBuildingsSearch.useQuery({ search: debouncedSearch, page, limit: 20 });

  const handleClose = () => {
    onClose();
  };

  const handleSelect = (building: Building) => {
    onSelect(building);
    onClose();
  };

  if (getBuildings.isPending) return <LoadingData />;
  if (!getBuildings.data) return <ElementNotFound />;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={handleClose}
      onKeyDown={handleClose}
    >
      <div className="w-full h-full relative">
        <div
          className="bg-white rounded-t-lg shadow-lg w-[60%] h-[90%] absolute bottom-0 left-[20%] flex flex-col"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <div className="bg-[#EBEBEB] rounded-t-lg flex justify-between items-center p-2 relative h-20 flex-shrink-0">
            <h2 className="text-center text-[24px] font-bold mx-auto">物件を設定する</h2>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-700 absolute font-bold text-[30px] top-[20px] right-[45px]"
              onClick={handleClose}
            >
              &times;
            </button>
          </div>

          <div className="mx-10 mt-10">
            <input
              type="text"
              className="w-full border border-gray-200 rounded-md px-4 py-2"
              placeholder="スタッフ名 / カナ で検索"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <BuildingTable buildings={getBuildings.data.buildings ?? []} onSelect={handleSelect} />
          <div className="flex justify-center my-4 flex-row gap-8">
            <button
              type="button"
              className="join-item btn"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              «
            </button>
            <div className="flex flex-row gap-2 items-center">
              <span className="text-sm font-bold">{page}</span>
              <span className="text-sm">/</span>
              <span className="text-sm font-bold">{getBuildings.data.totalPages}</span>
            </div>

            <button
              type="button"
              className="join-item btn"
              onClick={() => setPage((p) => Math.min(getBuildings.data.totalPages, p + 1))}
              disabled={page === getBuildings.data.totalPages}
            >
              »
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
